import React, { useEffect, useState } from 'react';
import { faAngleLeft, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { api } from '../services';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Tooltip,
} from '@mui/material';

const baseUrlCRM = process.env.REACT_APP_CRMFILE_SERVER;
const BaseURLDownload = process.env.REACT_APP_CRMFILE_SERVER || "https://dr.saloutieyeclinic.com/";

export const DoctorOnline = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // handler for edit/upload action
  const handleEditUpload = (item) => {
    try {
      localStorage.setItem('requestid', String(item.ccid ?? item.CCID ?? ''));
      
    } catch (e) {
      console.warn('Failed to set requestid in localStorage', e);
    }
    navigate('/UploadFiles', { state: { appointmentData: item } });
  };
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({ open: false, fileUrl: '', message: '', severity: 'success' });
  const key = localStorage.getItem('key');

  const searchBimar = async (mobile) => {
    try {
      const response = await fetch(
        `${baseUrlCRM}api/doapi?apikey=${process.env.REACT_APP_API_KEY}&func=SearchBimar&Mobile=${mobile}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        }
      );

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (error) {
        console.error('Invalid JSON response from SearchBimar:', text);
        throw new Error('پاسخ سرور نامعتبر است');
      }

      return data;
    } catch (error) {
      console.error('Error searching patient:', error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const profileResponse = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=1`);
        let profileData = profileResponse.data;

        if (typeof profileData === 'string') {
          try {
            profileData = JSON.parse(profileData);
          } catch (error) {
            console.error('Invalid JSON string:', profileData);
            setModal({ open: true, message: 'خطا در دریافت اطلاعات پروفایل', severity: 'error' });
            return;
          }
        }

        const mobile = profileData[0]?.Mobile;
        if (!mobile) {
          setModal({ open: true, message: 'شماره موبایل یافت نشد', severity: 'error' });
          return;
        }

        const searchBimarResponse = await searchBimar(mobile);
        console.log('Search Bimar Response:', searchBimarResponse);
        const ccid = searchBimarResponse[0]?.ccid;
        console.log('CCID (BimarID):', ccid);

        if (!ccid) {
          setModal({ open: true, message: 'شناسه بیمار یافت نشد', severity: 'error' });
          return;
        }

        const requestsResponse = await api.get(
          `${baseUrlCRM}api/doapi?func=GetAllRequest&BimarID=${ccid}`
        );

        console.log('Full API URL:', `${baseUrlCRM}api/doapi?func=GetAllRequest&BimarID=${ccid}`);
        console.log('API Response:', requestsResponse);
        console.log('BimarID used:', ccid);

        let processedRequests = requestsResponse.data;
        console.log('Response Data:', processedRequests);

        if (typeof processedRequests === 'string') {
          try {
            processedRequests = JSON.parse(processedRequests);
            console.log('Parsed Data:', processedRequests);
          } catch (error) {
            console.error('Invalid JSON response:', processedRequests);
            throw new Error('پاسخ سرور نامعتبر است');
          }
        }

        // Check if there are no requests
        if (!processedRequests || processedRequests.length === 0) {
          setModal({ 
            open: true, 
            fileUrl: '', 
            message: 'نسخه ای برای شما ثبت نشده است', 
            severity: 'error' 
          });
          return;
        }

        console.log('Processed Requests:', processedRequests);
        setRequests(processedRequests);
      } catch (error) {
        console.error('Error fetching data:', error);
        setModal({ open: true, message: 'خطا در دریافت داده‌ها', severity: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleShowFile = (fileUrl) => {
    if (fileUrl) {
      const fileExtension = fileUrl.split('.').pop().toLowerCase();
      const isAudioFile = ['mp3', 'wav', 'ogg', 'm4a', 'aac'].includes(fileExtension);
      
      setModal({ 
        open: true, 
        fileUrl, 
        message: '', 
        severity: 'success',
        isAudioFile 
      });
    } else {
      setModal({ open: true, fileUrl: '', message: 'فایلی وجود ندارد', severity: 'error' });
    }
  };

  const handleCloseModal = () => {
    setModal({ ...modal, open: false, fileUrl: '', message: '' });
    if (modal.severity === 'error') {
      navigate('/');
    }
  };

  const isAudioFile = (url) => {
    if (!url) return false;
    const fileExtension = url.split('.').pop().toLowerCase();
    return ['mp3', 'wav', 'ogg', 'm4a', 'aac'].includes(fileExtension);
  };

  const getAudioUrl = (fileName) => {
    if (!fileName) return '';
    return `${BaseURLDownload}DM/${fileName}`;
  };

  const handleAudioError = (e, fileName) => {
    console.error('Audio Error Details:', {
      fileName,
      url: getAudioUrl(fileName),
      error: e.target.error
    });
    setModal({ 
      open: true, 
      message: 'خطا در بارگذاری فایل صوتی. لطفاً دوباره تلاش کنید.', 
      severity: 'error' 
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: blur(4px);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            animation: fadeIn 0.3s ease-in-out;
          }
          .modal-content {
            background: #fff;
            padding: 24px;
            border-radius: 12px;
            max-width: 450px;
            width: 90%;
            text-align: center;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
            animation: slideIn 0.3s ease-in-out;
            font-family: 'Arial', sans-serif;
          }
          .modal-content h4 {
            margin: 0 0 16px;
            font-size: 1.5rem;
            color: ${modal.severity === 'success' ? '#1a8e3b' : '#c62828'};
          }
          .modal-content p {
            margin: 0 0 20px;
            font-size: 1rem;
            color: #333;
          }
          .modal-content .button-group {
            display: flex;
            gap: 12px;
            justify-content: center;
            flex-wrap: wrap;
          }
          .modal-content button, .modal-content a {
            padding: 10px 20px;
            border: none;
            border-radius: 8px;
            font-size: 1rem;
            cursor: pointer;
            text-decoration: none;
            transition: background 0.2s, transform 0.1s;
          }
          .modal-content button {
            background: #1976d2;
            color: #fff;
          }
          .modal-content button:hover {
            background: #1565c0;
            transform: translateY(-2px);
          }
          .modal-content a.view-file {
            background: #388e3c;
            color: #fff;
          }
          .modal-content a.view-file:hover {
            background: #2e7d32;
            transform: translateY(-2px);
          }
          .modal-content a.download-file {
            background: #0288d1;
            color: #fff;
          }
          .modal-content a.download-file:hover {
            background: #0277bd;
            transform: translateY(-2px);
          }
          .modal-content .error-button {
            background: #c62828;
            color: #fff;
            margin-top: 10px;
          }
          .modal-content .error-button:hover {
            background: #b71c1c;
            transform: translateY(-2px);
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideIn {
            from { transform: translateY(-20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
      <div className="container mt-xl-0">
       
        <div className="row mb-4 mt-2">
          <div className="col-lg-12 path">
            <ul>
              <li>
                <Link className="text-decoration-none" to="/">
                  صفحه اصلی
                </Link>
                <FontAwesomeIcon icon={faAngleLeft} className="mr-3" />
              </li>
              {location.state?.from && (
                <li>
                  <span style={{ cursor: 'pointer' }} onClick={handleBack} className="text-primary">
                    {location.state.from}
                  </span>
                  <FontAwesomeIcon icon={faAngleLeft} className="mr-3" />
                </li>
              )}
              <li>
                <span>نسخه پزشک</span>
              </li>
            </ul>
          </div>
        </div>
 {/* دکمه درخواست جدید */}
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 12 }}>
          <Link to="/Onlinevisit?CategoryID=48" className="text-decoration-none">
            <Button variant="contained" color="primary">درخواست جدید</Button>
          </Link>
        </div>
        <TableContainer className="mb-5" component={Paper} dir="rtl" sx={{ maxWidth: '100%', marginTop: '20px' }}>
          <Table sx={{ minWidth: 650, tableLayout: 'fixed' }} aria-label="requests table">
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ width: '10%' }}>ردیف</TableCell>
                <TableCell align="center" sx={{ width: '20%' }}>تاریخ ثبت</TableCell>
                <TableCell align="center" sx={{ width: '40%' }}>کامنت پزشک</TableCell>
                <TableCell align="center" sx={{ width: '30%' }}>پیام صوتی / فایل</TableCell>
                <TableCell align="center" sx={{ width: '40%' }}>وضعیت درخواست </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : requests.length > 0 ? (
                
                requests.map((item, index) => (
                  <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">{item.SabtDate} </TableCell>
                    <TableCell align="center">
                      <Tooltip title={item.DoctorComment || 'بدون کامنت'} arrow>
                        <span>{item.DoctorComment || 'بدون کامنت'}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      {item.DoctorFile ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                          <div style={{ width: '100%', maxWidth: '300px' }}>
                            <audio 
                              key={item.DoctorFile}
                              controls
                              style={{ width: '100%' }}
                              onError={(e) => handleAudioError(e, item.DoctorFile)}
                            >
                              <source 
                                src={getAudioUrl(item.DoctorFile)} 
                                type="audio/mpeg"
                              />
                              مرورگر شما از پخش فایل صوتی پشتیبانی نمی‌کند.
                            </audio>
                          </div>
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            href={getAudioUrl(item.DoctorFile)}
                            download
                            target="_blank"
                          >
                            دانلود پیام صوتی
                          </Button>
                        </div>
                      ) : (
                        <span style={{ color: '#666' }}>بدون فایل</span>
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                      {(() => {
                        const code = Number(item.vcode);
                        const color = code === 101 ? '#28a745' /* green */ : code === 100 ? '#007bff' /* blue */ : '#000' /* black */;
                        return <span style={{ color }}>{item.Vaziat}</span>;
                      })()}
                      {/* اگر وضعیت در حال بررسی است آیکون مداد برای ویرایش/بارگذاری مدارک نمایش بده */}
                      {String(item.vcode || '').includes('104') && (
                        <Tooltip title="ویرایش / بارگذاری مدارک" arrow>
                          <span
                            onClick={() => handleEditUpload(item)}
                            style={{ cursor: 'pointer', color: '#1976d2', display: 'inline-flex', alignItems: 'center' }}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </span>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    درخواستی یافت نشد
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {modal.open && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>{modal.severity === 'success' ? 'نمایش فایل' : 'پیام سیستم'}</h4>
            {modal.fileUrl ? (
              <div>
                <p>فایل پزشک:</p>
                <div className="button-group">
                  {modal.isAudioFile ? (
                    <div style={{ width: '100%', marginBottom: '20px' }}>
                      <audio controls style={{ width: '100%' }}>
                        <source src={modal.fileUrl} type={`audio/${modal.fileUrl.split('.').pop()}`} />
                        مرورگر شما از پخش فایل صوتی پشتیبانی نمی‌کند.
                      </audio>
                    </div>
                  ) : (
                    <a
                      href={modal.fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view-file"
                    >
                      باز کردن فایل
                    </a>
                  )}
                  <a
                    href={modal.fileUrl}
                    download
                    className="download-file"
                  >
                    دانلود فایل
                  </a>
                  <button onClick={handleCloseModal}>بستن</button>
                </div>
              </div>
            ) : (
              <>
                <p>{modal.message}</p>
                <button onClick={handleCloseModal} className="error-button">
                  بازگشت به صفحه اصلی
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};